export default __webpack_public_path__ + "static/media/gym.c8efc15f.png";